import React, { useContext } from 'react';
import { Fab } from '@mui/material';
import { VersionContext } from '../contexts/VersionContext';
import useMediaQuery from '@mui/material/useMediaQuery';
import { fetchBackendVersion } from './api';

const VersionUpdateButton = () => {
  const isMobile = useMediaQuery('(max-width:600px)');

  const { isNewVersionAvailable, resetVersionState } = useContext(VersionContext);

  const handleRefresh = async () => {
    resetVersionState();
    const latestVersion = await fetchBackendVersion();
    localStorage.setItem('backendVersion', latestVersion);
    window.location.reload(true); // Перезагружаем страницу
  };

  if (!isNewVersionAvailable) return null;

  return (
    <Fab
      color='secondary'
      onClick={handleRefresh}
      sx={{
        fontWeight: 600,
        backgroundColor: 'secondary',
        position: 'absolute',
        bottom: '58px',
        left: isMobile ? '0' : 'calc(50% - 305px)',
        width: '100%',
        maxWidth: '600px',
        height: '80px',
        lineHeight: '30px',
        padding: '15px',
        zIndex: '98',
        borderRadius: '0',
        '&.Mui-disabled': {
          backgroundColor: '#4b4b4b',
          color: 'white',
        },
      }}
    >
      Обновить до последней версии
    </Fab>
  );
};

export default VersionUpdateButton;
